import { styled } from '@mui/material/styles';
import { Button, IconButton, Paper, TextField } from '@mui/material';

const IMAGE = 100;

export const BlockOverlay = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: -100,
  backgroundColor: 'rgba(255,0,0,0.1)',
});

export const CommentField = styled(TextField, {
  shouldForwardProp: (prop) => !['overwritten', 'withClose'].includes(prop),
})(({ theme, overwritten, withClose }) => ({
  width: '100%',
  backgroundColor: overwritten ? theme.palette.background.paper : theme.palette.action.disabled,
  boxShadow: 'inset 2px 2px 5px rgba(0,0,0,0.3)',

  '& .MuiOutlinedInput-root': {
    border: 'none !important',
    padding: '6px 0 7px',

    '& fieldset': {
      border: 'none !important',
    },
    '& input': {
      padding: 0,
    },
  },
  '& textarea': {
    margin: theme.spacing(1),
    ...(withClose && { marginRight: theme.spacing(5) }),
  },
  '& .MuiFormHelperText-root': {
    position: 'relative',
    bottom: -20,
    marginLeft: 0,
  },
}));

export const CameraContainer = styled(Paper)({
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0,0,0,0.8)',
});

export const CloseCamera = styled(Button)({
  position: 'absolute',
  top: 10,
  right: 10,
});

export const ImageWrap = styled('div')(({ theme }) => ({
  position: 'relative',
  margin: theme.spacing(1),
  width: IMAGE,
}));

export const ImageDelete = styled(IconButton)({
  position: 'absolute',
  top: 0,
  right: 0,
});

export const CommentBtnContainer = styled('div')({
  marginTop: 27,
});

export const CommentBtn = styled('div')(({ theme }) => ({
  width: '100%',
  marginBottom: 5,
  position: 'relative',

  '& .placeholderContent': {
    width: IMAGE,
    height: IMAGE + 40,
    backgroundColor: theme.palette.action.disabledBackground,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const ImageSelectBtnWrap = styled('div')({
  position: 'absolute',
  top: 10,
  left: 10,
});

export const ExpandBtn = styled('div')(({ theme }) => ({
  width: '100%',
  color: theme.palette.text.primary,
}));
